var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99985 3.77248C13.5039 3.77248 16.3446 6.61313 16.3446 10.1172V17.731C16.3446 18.4318 15.7765 18.9999 15.0757 18.9999H4.92404C4.22322 18.9999 3.65509 18.4318 3.65509 17.731V10.1172C3.65509 6.61313 6.49574 3.77248 9.99985 3.77248ZM9.99985 3.77248V0.600098M5.55851 15.193H14.4412M2.5 10.7517V15.8275M17.5 10.7517V15.8275M7.46194 12.6551C6.76113 12.6551 6.19299 12.087 6.19299 11.3862C6.19299 10.6854 6.76113 10.1172 7.46194 10.1172C8.16276 10.1172 8.7309 10.6854 8.7309 11.3862C8.7309 12.087 8.16276 12.6551 7.46194 12.6551ZM12.5378 12.6551C11.8369 12.6551 11.2688 12.087 11.2688 11.3862C11.2688 10.6854 11.8369 10.1172 12.5378 10.1172C13.2386 10.1172 13.8067 10.6854 13.8067 11.3862C13.8067 12.087 13.2386 12.6551 12.5378 12.6551Z",
    stroke: "#363870",
    strokeWidth: 1.26895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.d9bb55bed98e0e062c6e9b04b9660bd7.svg";
export { ForwardRef as ReactComponent };